import { NewsletterPageContextValue } from "contexts/new/NewsletterPageContext";
import { trackEvent } from "services/frontend/Segment";
import {
  SegmentClientEvent,
  getSegmentEventIDForSubscriber,
} from "services/shared/SegmentEvents";
import Cookies from "js-cookie";
import {
  fbPixelCookieName,
  fbClickIdCookieName,
} from "services/shared/CookieNames";

export function useRecordNewsletterSubscribed(
  context?: NewsletterPageContextValue
) {
  const recordNewsletterSubscribed = (
    email: string,
    content_name: string,
    subscriberId: string
  ) => {
    trackEvent(SegmentClientEvent.newsletterSubscribed, {
      email,
      content_category: "newsletter",
      content_name,
      currency: "USD",
      value: 0.0,
      external_id: subscriberId,
      referral: context?.referral ?? false,
      referred_email: email,
      referrer_email: context?.referrer_email ?? "",
      fbp: Cookies.get(fbPixelCookieName),
      fbc: Cookies.get(fbClickIdCookieName),
      event_id: getSegmentEventIDForSubscriber(
        SegmentClientEvent.newsletterSubscribed,
        subscriberId
      ),
    });
  };

  return recordNewsletterSubscribed;
}
